import moment from "moment-timezone";
import { getUnit, formatUnitValue, unformatUnitValue } from "../einheiten/Units";

export const formatDate = (date, intl, x_range, tz) => {
	const m = moment(date);
	m.tz(tz);

	let show_long = true;
	if (x_range && Array.isArray(x_range) && x_range.length >= 2) {
		let diff = x_range[1] - x_range[0];
		if (diff <= 12 * 60 * 60 * 1000) {
			show_long = false;
		}
	}
	if (!m || !isFinite(date)) {
		return "---";
	}

	if (show_long) {
		return m.format("YYYY-MM-DD") + "\n" + m.format("HH:mm:ss");
	}
	return m.format("HH:mm:ss");
};

export const formatValue = (value, y_value, units, intl) => {
	/* 0 darf value schon werden, aber halt nicht null oder undefined */
	if (value === null || value === undefined) {
		return "---";
	}
	let unit = getUnit(units[y_value.unit]);
	return formatUnitValue(value, unit, intl);
};

export const unformatValue = (value, y_value, units) => {
	if (value === null || value === undefined) {
		return "---";
	}
	let unit = getUnit(units[y_value.unit]);
	return unformatUnitValue(value, unit);
};

export const formatValueUnit = (y_value, units, intl) => {
	let unit = getUnit(units[y_value.unit]);
	return unit.genUnitText(intl);
};